import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import "./ExpandedVideo.css";

export default function ExpandedVideo({ video, title, onClose }) {
  const closeRef = useRef(null);
  useEffect(() => {
    const previousFocus = document.activeElement;
    closeRef.current?.focus();
    const handleKey = event => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener("keydown", handleKey);
      previousFocus?.focus();
    };
  }, [onClose]);
  const src = video.type === "youtube" ? video.src.replace("controls=0", "controls=1") : video.src;
  return createPortal(
    <div className="mg-expanded-video-backdrop" role="dialog" aria-modal="true" aria-label={`${title} video`} onClick={onClose}>
      <div className="mg-expanded-video" onClick={event => event.stopPropagation()}>
        {video.type === "file" ? <video src={src} autoPlay controls playsInline /> :
          <iframe title={`${title} video`} src={src}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen />}
        <button ref={closeRef} type="button" onClick={onClose} aria-label="Close video" title="Close video"><X size={20} /></button>
      </div>
    </div>, document.body,
  );
}
